import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import featuredManufacturerAction from '../app/store/actions/featuredManufacturer';

import Notification from '../components/notifications';
import itemsPage from '../data/itemsPage';

import Table from '../components/table/table';
import TableRegisterButton from '../components/table/registerButton';
import ModalComponent from '../components/modal';

import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class FeaturedManufacturerPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: itemsPage.page.limit,
      show: false,
      page: 1,
      search: '',
      showModal: false,
      orderBy: 'ASC',
      field: 'brandId',
    };
  }

  componentDidMount() {
    this.searchItems();
  }

  updateValues = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.searchItems();
  }

  searchItems = async () => {
    const {
      search, page, limit, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    await this.props.searchFeaturedManufacturer(limit, skip, search, orderBy, field);
  }

  deleteItemModal = async (categoryId, brandId) => {
    await this.setState({ selectItemToDelete: { categoryId, brandId }, showModal: true });
  }

  deleteItem = async () => {
    const { selectItemToDelete } = this.state;

    if (selectItemToDelete) {
      const { categoryId, brandId } = selectItemToDelete;
      await this.props.deleteItem(categoryId, brandId);
      await this.setState({ selectItemToDelete: undefined, showModal: false });
      await this.searchItems();
      this.deleteNotification();
    }
  }

  deleteNotification = () => {
    this.setState({ show: true });
    setTimeout(() => { this.setState({ show: false }); }, 5000);
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.searchItems();
  }

  render() {
    const {
      limit, show, page, showModal,
    } = this.state;
    const { manufacturers = {} } = this.props;

    const tableHeader = [
      { key: 'category', value: I18n.t('category') },
      { key: 'categoryId', value: I18n.t('categoryId') },
      { key: 'brand', value: I18n.t('brand') },
      { key: 'brandId', value: I18n.t('brandId') },
      { key: 'action', value: I18n.t('action') },
    ];

    const tableData = (manufacturers.rows || []).map((row, index) => ({
      key: index,
      category: row.category.name,
      categoryId: row.category.id,
      brand: row.brand.description,
      brandId: row.brand.id,
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <Translate value="action" />
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => this.deleteItemModal(row.category.id, row.brand.id)}
              >
                <Translate value="delete" />
              </button>
            </div>
          </div>
        </div>
      ),
    }));

    const tableButtons = (
      <React.Fragment>
        <TableRegisterButton route={{ pathname: ROUTES.FEATURED_MANUFACTURE_FORM }} />
        <button
          onClick={() => history.push(ROUTES.UPLOAD_FEATURED_MANUFACTURE)}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="import" />
        </button>

        <button
          onClick={() => this.props.getCsvCategBrandsReport()}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="export" />
        </button>
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">

        <ModalComponent
          title={I18n.t('delete')}
          body={I18n.t('deleteSpotlightModal')}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('confirm')}
          size={{ width: '300px', height: '170px' }}
          showButtons
          showCancel
          confirmModal={this.deleteItem}
        />

        <Table
          title={I18n.t('spotlightManufacturer')}
          buttons={tableButtons}
          header={tableHeader}
          lines={tableData}
          page={page}
          perPage={limit}
          count={manufacturers.count}
          searchItems={this.updateValues}
          showItemsCount
          sortTable={this.sortTable}
        />

        {show && <Notification classe="success" message={I18n.t('productDeleted')} /> }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  searchFeaturedManufacturer: (limit, skip, search, order, field) => dispatch(
    featuredManufacturerAction.getFeaturedManufacturer(limit, skip, search, order, field),
  ),
  deleteItem: (categoryId, brandId) => dispatch(
    featuredManufacturerAction.deleteFeaturedManufacturer(categoryId, brandId),
  ),
  getCsvCategBrandsReport: () => dispatch(
    featuredManufacturerAction.getCsvCategBrandsReport(),
  ),
});

const mapStateToProps = state => ({
  manufacturers: state.featuredManufacturer && state.featuredManufacturer.manufacturers,
});

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedManufacturerPage);
